// Add-to-cart for the merchant-configured add-on rows inside the cart drawer.
//
// Delegated from <cart-drawer> rather than bound per button, because the drawer
// replaces its own innerHTML on every cart update - per-button listeners would
// be discarded on the first render.
if (!window.__cartDrawerAddonsBound) {
  window.__cartDrawerAddonsBound = true;

  // Closes the drawer from the continue-shopping link under the checkout button.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-cart-continue-shopping]')) return;
    event.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-addon-add]');
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;

    const variantId = Number.parseInt(button.dataset.cartAddonAdd, 10);
    if (!Number.isFinite(variantId) || variantId <= 0) return;

    const drawer = document.querySelector('cart-drawer');
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    try {
      const body = { items: [{ id: variantId, quantity: 1 }] };

      // Ask for the same sections the drawer re-renders itself with, so the
      // line items, totals and free shipping bar all refresh in one round trip.
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(`${routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (result.status) {
        console.error('Cart drawer add-on failed:', result.description || result.message);
        return;
      }

      if (drawer && typeof drawer.renderContents === 'function') {
        // renderContents expects a single-item shape plus sections.
        drawer.renderContents({
          ...(Array.isArray(result.items) ? result.items[0] : result),
          sections: result.sections,
        });
      } else {
        window.location.reload();
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-addons', productVariantId: variantId });
      }
    } catch (error) {
      console.error('Cart drawer add-on request failed:', error);
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
    }
  });
}
